module.exports = __webpack_public_path__ + "img/2.2daa71e5.jpg";